export default "__VITE_ASSET__qoU1vriK__"